export const options_density_modeFull = "gld";
export const options_density_modeMedium = "hld";
export const options_density_modeCompact = "ild";
export const options_density_modeRoomy = "jld";
export const options_density_modeCozy = "kld";
export const options_density_modeLarge = "lld";
export const options_density_modeSmall = "mld";
export const options_density_quickSetting_label = "nld";
export const ariaStringForDensityQuickSetting = "old";
export const options_messageLineCount_three = "pld";
export const options_messageLineCount_one = "qld";
export const options_oneoutlook_density_quick_tooltip = "rld";
export default {options_density_modeFull,options_density_modeMedium,options_density_modeCompact,options_density_modeRoomy,options_density_modeCozy,options_density_modeLarge,options_density_modeSmall,options_density_quickSetting_label,ariaStringForDensityQuickSetting,options_messageLineCount_three,options_messageLineCount_one,options_oneoutlook_density_quick_tooltip};